<template>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand">
        <!-- Left navbar links -->
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
            </li>
        </ul>

        <!-- Right navbar links -->
        <ul class="navbar-nav ml-auto">

            <li class="nav-item">
                <a class="nav-link" href="#" role="button" @click.prevent="iniciarTutorial" title="Ayuda / Tutorial">
                    <i class="fas fa-question-circle"></i>
                </a>
            </li>
            <li class="nav-item"><ThemeSwitcher /></li>
            
            <!-- Notifications Dropdown Menu -->
            <li class="nav-item dropdown">
                <a class="nav-link" data-toggle="dropdown" href="#">
                    <i class="far fa-user"></i>
                </a>
                <div class="dropdown-menu  dropdown-menu-right">
                    <router-link to="/perfil" class="dropdown-item">
                        <i class="fas fa-user mr-2"></i> Mi Perfil
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a @click="logout" class="dropdown-item">
                        <i class="fas fa-sign-out-alt mr-2"></i> Salir
                    </a>
                </div>
            </li>
            
        </ul>

    </nav>
    <!-- /.navbar -->

</template>
<script>
import { useAuth } from "@/composables/useAuth";
import { tutorial } from "@/plugins/tutorial";


export default {
    setup() {
        const { logout } = useAuth(); // ✅ Importa la función de logout

        function iniciarTutorial() {
            tutorial.play();
        }

        return { logout, iniciarTutorial };
    }
};
</script>